import { Component, OnInit, OnDestroy } from '@angular/core';
import { UntypedFormGroup, FormGroupDirective, NgForm, UntypedFormControl, Validators } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';
import { Router, ActivatedRoute } from '@angular/router';
import { UserModel } from '../../../models/user.model';
import { UserService } from '../../services/userService.service';
import { MessageService } from '../../services/messageService.service';
import { Subscription, Observable } from 'rxjs';
import { map, first } from 'rxjs/operators';
import { ReCaptchaV3Service, OnExecuteData } from 'ng-recaptcha';
// import { ShortUserModel } from '@src/models/shortUser.model';
import {MatDatepickerModule} from '@angular/material/datepicker';
import { DateAdapter } from '@angular/material/core';
// import Utils from '@src/app/helpers/Utils';
// import { environment } from '@src/  /environments/environment';
import { environment } from '../../../environments/environment';
import Utils from '../../../app/helpers/Utils';

/** Error when invalid control is dirty, touched, or submitted. */
export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: UntypedFormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

@Component({
    selector: 'app-userdataformkbw',
    templateUrl: './userdataformkbw.component.html',
    styleUrls: ['./userdataformkbw.component.scss'],
    providers: [MessageService],
    standalone: false
})
export class UserdataformComponentKbw implements OnInit, OnDestroy {

  userdataForm = new UntypedFormGroup({
    firstName: new UntypedFormControl('', [Validators.required, Validators.minLength(2)]),
    lastName: new UntypedFormControl('', [Validators.required, Validators.minLength(2)]),
    additionalDataValue: new UntypedFormControl('', [Validators.required, Validators.minLength(2)]),
    // birthDate: new FormControl('', [Validators.required, Validators.minLength(2)]),
    // documentNr: new FormControl('', [Validators.required, Validators.minLength(5)]),
    customerIdentifier: new UntypedFormControl('', [Validators.required, Validators.minLength(2)]),
    regulationAccept: new UntypedFormControl(false, Validators.requiredTrue),
    dataProcessAccept: new UntypedFormControl(false, Validators.requiredTrue),
    kbwAccept: new UntypedFormControl(false, Validators.requiredTrue)
    // date: new FormControl(Date(), Validators.requiredTrue)
  });
  myModel: any;
  public datemask = {
    guide: true,
    showMask : true,
    mask: [/\d/, /\d/, '-', /\d/, /\d/, '-',/\d/, /\d/,/\d/, /\d/]
  };
  matcher = new MyErrorStateMatcher();
  message: string;
  loading = false;
  subscription: Subscription;
  state$: Observable<object>;
  minDate: Date;
  maxDate: Date;
  private allExecutionsSubscription: Subscription;
  private singleExecutionSubscription: Subscription;
  public recentToken: string = '';
  public errors:any = [];
  public readonly executionLog: OnExecuteData[] = [];
  public selectedExam:string;
  public isContractor:boolean;


  constructor(
    private router: Router,
    private userService: UserService,
    private messageService: MessageService,
    public activatedRoute: ActivatedRoute,
    private recaptchaV3Service: ReCaptchaV3Service,
    private dateAdapter: DateAdapter<any>
    ) {
      const currentYear = new Date().getFullYear();
      this.minDate = new Date(currentYear - 80, 0, 1);
      this.maxDate = new Date(currentYear - 14, 0, 1);

      let envLang = sessionStorage.getItem(environment.sessionLang);
      // Find the position of the hyphen
      if(envLang == null){
        envLang = 'pl-PL';
      }
      let hyphenIndex = envLang.indexOf('-');

      // Extract characters up to the first hyphen
      let lang = hyphenIndex !== -1 ? envLang.substring(0, hyphenIndex) : envLang;

      this.dateAdapter.setLocale(lang);
    }
    private onTouchedCallback: () => void;
    private onChangeCallback: (_: any) => void;
  ngOnDestroy(): void {
    if (this.allExecutionsSubscription) {
      this.allExecutionsSubscription.unsubscribe();
    }
    if (this.singleExecutionSubscription) {
      this.singleExecutionSubscription.unsubscribe();
    }
  }

  ngOnInit() {
    sessionStorage.removeItem('token');
    this.selectedExam = sessionStorage.getItem('selectedExam');
    if(this.selectedExam === "6"){
      this.isContractor = true;
    }
    this.allExecutionsSubscription = this.recaptchaV3Service.onExecute
      .subscribe((data) => this.executionLog.push(data));
  }

  // get value(): Date {
  //   return this.userdataForm.controls.date.value;
  // };
  // set value(v: Date) {
  //   if (v !== this.userdataForm.controls.date.value) {
  //     this.userdataForm.controls.date.setValue(v);
  //   }
  // }
  // writeValue(value: any): void {
  //   if (value !== this.userdataForm.controls.date.value) {
  //     this.userdataForm.get('date').setValue(value);
  //   }
  // }
  // registerOnChange(fn: any): void {
  //   this.onChangeCallback = fn;
  // }
  // registerOnTouched(fn: any): void {
  //   this.onTouchedCallback = fn;
  // }
  // onChange(event) {
  //   console.log(event)
  //   // console.log(event);
  //   this.userdataForm.get('date').setValue(event);
  //   this.onBlur();
  // }
  // todate(value) {
  //   this.userdataForm.get('date').setValue(new Date(value));
  // }
  // onBlur() {
  //   if (this.userdataForm.controls.date) {
  //     this.onChangeCallback(this.userdataForm.controls.date);
  //   }
  // }

  onSubmit() {
    if (this.singleExecutionSubscription) {
      this.singleExecutionSubscription.unsubscribe();
    }
    this.singleExecutionSubscription = this.recaptchaV3Service.execute('onsubmit')
      .subscribe((token) => {
        this.recentToken = token;

        if (this.userdataForm.invalid) {
          return;
        }
        const userDataModel: UserModel = this.userdataForm.value;
        if(this.selectedExam == null){
          this.selectedExam = '1';
        }
        userDataModel.trainingTypeId = +this.selectedExam;
        userDataModel.customerIdentifierType = 'BirthDate';
        userDataModel.customerIdentifier = Utils.convertDate(userDataModel.customerIdentifier);
        userDataModel.additionalDataKey = "companyname";
        //userDataModel.customerIdentifierType = 'PHONE';
        // userDataModel.firstName = '';
        // userDataModel.lastName = '';
        // userDataModel.birthDate = '';

        this.userService.sendData(userDataModel).subscribe((res:any) => {
          try{
            sessionStorage.setItem('token', res.token);
            this.router.navigate(['/exam']);
          }
          catch{

          }
        });
      },
      (error) => {
        this.errors = [ 'Error trying to verify request (reCaptcha v3)' ];
        console.log(this.errors);
      });
  }

  // public executeImportantAction(): void {
  //   this.recaptchaV3Service.execute('importantAction')
  //     .subscribe((token) => this.handleToken(token));
  // }
  // handleToken(token){
  //   console.log(token);
  // }
}
